import AwesomeDebouncePromise from 'awesome-debounce-promise';
import axios from 'axios';
import * as environment from '../../../environment';
import { currentRegion, currentEnvironment } from '../../../helpers';

export interface ShopifyBlogArticle {
  author: string;
  blog_id: number;
  body_html: string;
  created_at: string;
  id: number;
  handle: string;
  image?: {
    src: string;
    created_at: string;
  };
  metafields: {
    key: string;
    value: string;
    type: string;
    namespace: string;
  };
  published: string;
  published_at: string;
  summary_html: string;
  tags: string;
  template_suffix: string;
  title: string;
  updated_at: string;
  user_id: number;
}

export interface ShopifyGetBlogsResponse {
  response?: ShopifyBlogArticle[];
  error?: any;
}

const shopifyRequest = (requestUrl: string, headers: any) =>
  axios.get(requestUrl, headers);
const shopifyDebounced = AwesomeDebouncePromise(shopifyRequest, 250);

const SPECTRA_ACTIVE = true;

export const shopifyGetBlogs = async (): Promise<ShopifyGetBlogsResponse> => {
  const region = currentRegion();
  const application = currentEnvironment();

  let error = null;
  let dataResponse = null;

  if (!SPECTRA_ACTIVE) {
    return {
      response: [],
      error,
    };
  }

  const externalGateway = environment.envApolloUrls[application].external;

  const requestUrl = externalGateway + '/v1/shopify/blogs';

  try {
    const headers = {
      headers: {
        'x-waldo-region': region,
      },
    };

    const response = await shopifyDebounced(requestUrl, headers);
    dataResponse = ((response.data as any)?.data || []) as ShopifyBlogArticle[];
  } catch (errorResponse) {
    error = errorResponse;
  }

  return {
    response: dataResponse ? dataResponse : undefined,
    error,
  };
};
